<template>
  <b-button
    :aria-label="ariaLabel"
    :type="type"
    :tabindex="tabindex"
    v-on="$listeners"
    v-bind="$attrs"
    :title="title"
  >
    <slot></slot>
  </b-button>
</template>

<script>
export default {
  name: "BaseBuefyButton",
  inheritAttrs: false,

  props: {
    ariaLabel: { type: String, required: true },
    type: { type: String, required: false, default: "button" },
    tabindex: { type: [String, Number], required: false },
    title: { type: String, required: false }
  }
};
</script>
